import UserLayout from "../components/UserLayout";
import Home from "../components/Home";
const HomePage = () => {
    return (
        <UserLayout>
            <Home />
        </UserLayout>
    );
}

export default HomePage;